import React, { useEffect, useState } from "react";
import { AdresseService } from "../services/AdresseService.js";
import "./DevisAdresseLivPicker.css";

export default function DevisAdresseLivPicker({ clientId, onClose, onSelect }) {
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAddresses = async () => {
      try {
        const service = new AdresseService();
        const data = await service.getAllAdresses();
        // Filtrer pour ne garder que les adresses de ce client spécifique
        const clientAddresses = data.filter(a => a.clientId === clientId);
        setAddresses(clientAddresses);
      } catch (e) {
        console.error("Error loading addresses", e);
      } finally {
        setLoading(false);
      }
    };
    
    if (clientId) {
      loadAddresses();
    } else {
      setLoading(false);
    }
  }, [clientId]);

  const handleConfirm = () => {
    if (selectedAddress) {
      onSelect(selectedAddress); // Renvoie l'objet adresse entier au parent
    }
    onClose();
  };

  if (loading) return <div className="picker-overlay"><div className="picker-container"><p>Chargement des adresses...</p></div></div>;

  return (
    <div className="picker-overlay">
      <div className="picker-container">
        <h2 className="picker-title">Sélectionner une Adresse de Livraison</h2>
        
        <div className="picker-table-wrapper">
          <table className="picker-table">
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>Type</th>
                <th>Adresse 1</th>
                <th>Adresse 2</th>
                <th>Code Postal</th>
                <th>Ville</th>
              </tr>
            </thead>
            <tbody>
              {!clientId ? (
                <tr><td colSpan="5" style={{ textAlign: "center", padding: "20px", color: "red" }}>Veuillez d'abord sélectionner un client.</td></tr>
              ) : addresses.length === 0 ? (
                <tr><td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>Aucune adresse trouvée pour ce client</td></tr>
              ) : (
                addresses.map((a) => (
                  <tr 
                    key={a.id} 
                    className={`picker-row ${selectedAddress?.id === a.id ? "selected" : ""}`}
                    onClick={() => setSelectedAddress(a)}
                  >
                    <td>
                      <input 
                        type="radio" 
                        name="addressSelect" 
                        checked={selectedAddress?.id === a.id} 
                        onChange={() => setSelectedAddress(a)} 
                      />
                    </td>
                    <td>{a.type || 'N/A'}</td>
                    <td>{a.adresse1 || 'N/A'}</td>
                    <td>{a.adresse2 || '-'}</td>
                    <td>{a.codePostal || 'N/A'}</td>
                    <td>{a.ville || 'N/A'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="picker-actions">
          <button className="picker-btn" onClick={handleConfirm} disabled={!selectedAddress}>
            Sélectionner
          </button>
          <button className="picker-btn-secondary" onClick={onClose}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}